import React, { useEffect, useState } from "react";
import {
  View,
  Text,
  Image,
  FlatList,
  StyleSheet,
  ActivityIndicator,
  TouchableOpacity,
  Platform,
  RefreshControl,
} from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { useNavigation } from "@react-navigation/native";
import axios from 'axios';
import API_PATHS from '../src/apiCalls/ApiPath'

const typeDescriptionMap = {
  HOMECARE: 'At Home Care',
  LEARNCARE: 'At Learning Center',
  TRANSPORT: 'Transportation',
  BIRTHDAY: 'Birthday Party',
  VENREN: 'Venue Rental',
  TRANSLEARN: 'Learning Care/Transport',
  BREAKFASTCLUB: 'Breakfast Club',
  SOCIALHUB: 'Social Hub',
};

const statusStyles = {
  waiting: {
    color: '#00BFFF',
    backgroundColor: '#00BFFF66',
    label: 'waiting'
  },
  approved: {
    color: '#B7410E',
    backgroundColor: '#B7410E66',
    label: 'approved'
  },
  completed: {
    color: '#556B2F',
    backgroundColor: '#556B2F66',
    label: 'completed'
  },
  cancelled: {
    color: '#964B00',
    backgroundColor: '#964B0066',
    label: 'cancelled'
  }
};

const timeConverter = (epochTime) => {
  if (!epochTime) return '';
  const myDate = new Date(epochTime * 1000);
  const day = myDate.getDate().toString().padStart(2, "0");
  const month = myDate.toLocaleString("default", { month: "short" });
  const year = myDate.getFullYear().toString().slice(2);
  return `${day}-${month}-${year}`;
};

const RecurringScreen = () => {
  const [loading, setLoading] = useState(true);
  const [bookings, setBookings] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const navigation = useNavigation();

  // const TOKEN =
  //   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJETEMxOTY1NCIsImVtYWlsIjoic2luaGFnYXVyYXYwMTBAZ21haWwuY29tIiwidXNlcnR5cGUiOjEwMCwiaWF0IjoxNzM0Nzc0NTk4fQ.v4p7VGy-g-QTyOVkRmuF-s0ATcg2DuXnEW7fEjKz_Tg";

  //const BASE_URL = 'https://api.danileeshelpinghands.org';

  const fetchBookings = async (pageNumber = 1) => {
    const token = await AsyncStorage.getItem("token")
    if (!token) {
      //console.error("No token found")
      //setError("Authentication error. Please log in again.")
      return
    }
    //console.log("Fetching notifications with token:", token)
    if (!hasMore && pageNumber > 1) return;
    setLoading(true);
    try {
      const response = await axios.post(
        `${API_PATHS.BASE_URL}${API_PATHS.GET_ALL_RECURRINGS2}`,
        { page: pageNumber, limit: 10 },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        }
      );

      if (response.data.Success === 1) {
        const newBookings = response.data.Data.recurringBookings.map((booking, index) => ({
          ...booking,
          uniqueId: `${booking.recurringId}-${Date.now()}-${index}`,
        }));
        setBookings(prevBookings => pageNumber === 1 ? newBookings : [...prevBookings, ...newBookings]);
        setHasMore(newBookings.length === 10);
        setPage(pageNumber);
      } else {
        //console.log("Error fetching data:", response.data.Message);
        setHasMore(false);
      }
    } catch (error) {
      //console.error("Error fetching data:", error);
      setHasMore(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBookings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRefresh = async () => {
    setRefreshing(true);
    setPage(1);
    setHasMore(true);
    await fetchBookings(1);
    setRefreshing(false);
  };

  const handleLoadMore = () => {
    if (!loading && hasMore) {
      fetchBookings(page + 1);
    }
  };

  const renderFooter = () => {
    if (!loading) return null;
    return <ActivityIndicator style={styles.loader} />;
  };

  const handleItemClick = (item) => {
    navigation.navigate("RecurringDetails", { recurringId: item.recurringId });
  };

  const handleProfileClick = () => {
    navigation.navigate("DetailsTab");
  };

  const StatusBadge = ({ status }) => (
    <View
      style={[
        styles.statusBadge,
        { backgroundColor: statusStyles[status]?.backgroundColor || '#E5F7FF' },
      ]}>
      <Text
        style={[
          styles.statusText,
          { color: statusStyles[status]?.color || '#00BFFF' },
        ]}>
        {statusStyles[status]?.label || 'Waiting'}
      </Text>
    </View>
  );

  const renderItem = ({ item }) => (
    <TouchableOpacity onPress={() => handleItemClick(item)}>
      <View style={styles.itemContainer}>
        <View style={styles.itemContent}>
          <View style={styles.itemDetails}>
            <Text style={styles.planName}>
              {item.planDetails.planPackage} - {item.planDetails.planName}
              <Text style={{ fontFamily: Platform.OS === "android" ? "FacebookSansRegular" : "Facebook Sans", fontSize: 18, color: "#1A1A1A" }}>
                {' '}({item.planDetails.planNoOfKid}-Child){item.planDetails.planType !== "1" && ` - ${item.planDetails.planType}`}
              </Text>
            </Text>
            <View style={styles.detailsRow}>
              <View style={styles.detailsText}>
                <Text style={styles.serviceType}>
                  {typeDescriptionMap[item.type]}, starts from: {timeConverter(item.startDate)}
                </Text>
                <Text style={styles.weekDays}>
                  {item.bookingType === "Daily"
                    ? "Daily"
                    : item.weekDays && item.weekDays.length > 0
                      ? item.weekDays.join(", ")
                      : "No specific days"}
                </Text>
              </View>
              <StatusBadge status={item.status} />
            </View>
          </View>
        </View>
      </View>
    </TouchableOpacity>
  );

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <TouchableOpacity onPress={handleProfileClick}>
          <View style={styles.circle}>
            <Image
              source={require("./assets/A.png")}
              style={styles.profileImage}
            />
          </View>
        </TouchableOpacity >
        <Text style={styles.headerText}>Recurring</Text>
        <TouchableOpacity onPress={() => navigation.navigate('Notification')}>
          <Image
            source={require("./assets/notification1.png")}
            style={styles.notificationIcon}
          />
        </TouchableOpacity>
      </View>
      {loading && page === 1 ? (
        <ActivityIndicator size="large" color="#A6CE39" style={styles.loader} />
      ) : (
        <FlatList
          data={bookings}
          renderItem={renderItem}
          keyExtractor={(item) => item.uniqueId}
          contentContainerStyle={styles.list}
          onEndReached={handleLoadMore}
          onEndReachedThreshold={0.1}
          ListFooterComponent={renderFooter}
          refreshControl={<RefreshControl refreshing={refreshing} onRefresh={handleRefresh} colors={["#A6CE39"]} />}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#ffffff",
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#A6CE39",
    paddingHorizontal: 15,
    paddingVertical: 15,
  },
  profileImage: {
    width: 35,
    height: 35,
    resizeMode: "contain",
  },
  headerText: {
    fontFamily: Platform.OS === "android" ? "FacebookSansRegular" : "Facebook Sans",
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: 26,
    color: "#ffffff",
  },
  notificationIcon: {
    width: 30,
    height: 30,
    resizeMode: "contain",
  },
  list: {
    padding: 15,
  },
  itemContainer: {
    marginBottom: 15,
    borderBottomWidth: 1,
    borderBottomColor: "#E0E0E0",
    paddingBottom: 8,
  },
  itemContent: {
    flexDirection: "row",
  },
  itemDetails: {
    flex: 1,
  },
  detailsRow: {
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 8,
    marginTop: 2,
  },
  detailsText: {
    flex: 1,
  },
  planName: {
    fontFamily: Platform.OS === "android" ? "FacebookSansRegular" : "Facebook Sans",
    fontSize: 18,
    color: "#1A1A1A",
    marginBottom: 4,
  },
  serviceType: {
    fontFamily: Platform.OS === "android" ? "FacebookSansRegular" : "Facebook Sans",
    lineHeight: 16,
    fontSize: 12,
    color: "#666666",
    marginBottom: 6,
  },
  weekDays: {
    fontFamily: Platform.OS === "android" ? "FacebookSansRegular" : "Facebook Sans",
    fontStyle: 'normal',
    fontWeight: 'normal',
    lineHeight: 16,
    fontSize: 12,
    color: "#666666",
    flexShrink: 1,
    marginRight: 8,
  },
  statusBadge: {
    alignSelf: 'flex-start',
    paddingHorizontal: 12,
    paddingVertical: 2,
    borderRadius: 16,
  },
  statusText: {
    fontSize: 16,
    fontFamily: Platform.OS === "android" ? "FacebookSansRegular" : "Facebook Sans",
    fontStyle: 'normal',
    fontWeight: 'bold',
  },
  nextIcon: {
    width: 10,
    height: 20,
    marginLeft: 5,
    marginTop: 5,
  },
  loader: {
    marginVertical: 20,
  },
});

export default RecurringScreen;

